
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Pourquoi faire appel à une agence Facebook Ads comme ALEO",
    description:
      "Faire appel à une agence spécialisée dans les Facebook Ads comme ALEO, partenaire META, peut grandement contribuer à atteindre ces buts de manière efficiente.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
